// extracted by mini-css-extract-plugin
export var equalColumn = "_ip-0";